<template>
    <div :class="cardClasses" @mouseover="hover = true" @mouseout="hover = false">
        <slot name="header" />

        <slot />

        <slot name="footer" />
    </div>
</template>

<script>
    export default {
        name: 'card',

        props: {
            dark: Boolean,
        },

        data() {
            return {
                hover: false,
            };
        },

        computed: {
            cardClasses() {
                let classes = ['card'];

                if (this.dark) {
                    classes.push('card-dark');
                }

                if (this.hover) {
                    classes.push('hover');
                }

                return classes.join(' ');
            },
        },
    }
</script>
